import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Laptop, Stethoscope, Leaf, Factory, BadgeIndianRupee, GraduationCap, Languages, Briefcase } from "lucide-react";

const programTypes = [
  {
    icon: Laptop,
    title: "IT & Digital Skills",
    description: "Coding, digital marketing, AI/ML basics",
    count: "Multiple Programs",
    color: "from-blue-500/20 to-blue-600/5",
  },
  {
    icon: Stethoscope,
    title: "Healthcare",
    description: "Nursing, pharmacy, lab technician",
    count: "Programs Listed",
    color: "from-red-500/20 to-red-600/5",
  },
  {
    icon: Leaf,
    title: "Green Jobs",
    description: "Solar, sustainability, agriculture",
    count: "Programs Listed",
    color: "from-green-500/20 to-green-600/5",
  },
  {
    icon: Factory,
    title: "Manufacturing & Logistics",
    description: "Industry skills, supply chain",
    count: "Programs Listed",
    color: "from-orange-500/20 to-orange-600/5",
  },
  {
    icon: BadgeIndianRupee,
    title: "Apprenticeships",
    description: "Earn while you learn programs",
    count: "Options Listed",
    color: "from-purple-500/20 to-purple-600/5",
  },
  {
    icon: GraduationCap,
    title: "Free Certifications",
    description: "Global platforms, provider-issued credentials",
    count: "Courses Listed",
    color: "from-teal-500/20 to-teal-600/5",
  },
  {
    icon: Languages,
    title: "English Skills",
    description: "Speaking, writing & interview confidence",
    count: "9+ Courses",
    color: "from-sky-500/20 to-sky-600/5",
  },
  {
    icon: Briefcase,
    title: "Employability After 12th",
    description: "Soft skills, digital marketing, Excel & tech basics",
    count: "7+ Programs",
    color: "from-amber-500/20 to-amber-600/5",
  },
];

export const ProgramTypesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-2">
              Explore by Sector
            </h2>
            <p className="text-muted-foreground">
              Find free programs in the field you're interested in.
            </p>
          </div>
          <Link 
            to="/programs" 
            className="text-primary font-semibold flex items-center gap-2 hover:gap-3 transition-all"
          >
            View All Programs
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {programTypes.map((program, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={`/programs?sector=${program.title.toLowerCase().replace(/ /g, '-')}`}
                className={`block p-6 rounded-2xl bg-gradient-to-br ${program.color} border border-border hover:shadow-card hover:-translate-y-1 transition-all duration-300`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 rounded-xl bg-card flex items-center justify-center shadow-soft">
                    <program.icon className="h-6 w-6 text-primary" />
                  </div>
                  <Badge variant="sector">{program.count}</Badge>
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-1">{program.title}</h3>
                <p className="text-sm text-muted-foreground">{program.description}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
